"use client";

import { Shield, CircleCheck as CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { motion } from 'framer-motion';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function Malwarebytes() {
  return <section data-section-id="4553" id="malwarebytesprovidercard" className="bg-[hsl(221,40%,4%)] text-white py-24 md:py-28 px-4 sm:px-6 lg:px-10 relative overflow-hidden">
      <div className="absolute top-10 left-10 text-[200px] font-bold text-white/5 select-none pointer-events-none">
        01
      </div>

      <div className="max-w-[1400px] mx-auto relative z-10">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <motion.div variants={itemVariants} className="flex items-start gap-6">
              <div className="flex flex-col items-center mt-2">
                <div className="w-px h-16 bg-gradient-to-b from-orange-500 to-transparent" />
              </div>
              
              <div>
                <span className="font-mono text-orange-500 uppercase tracking-[0.2em] text-5xl md:text-6xl mb-2 block">
                  01 // Malwarebytes
                </span>
                <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tighter">
                  Enterprise-Grade Malware Protection
                </h2>
              </div>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="lg:col-span-7">
            <Card className="bg-[hsl(221,30%,8%)] border border-[hsl(221,30%,15%)] shadow-2xl rounded-lg p-2 md:p-3 relative">
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-orange-500" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-orange-500" />
              
              <CardHeader className="pb-4">
                <div className="size-16 md:size-20 rounded-lg bg-orange-500/10 flex items-center justify-center mb-4">
                  <Shield className="size-8 md:size-10 text-orange-500" />
                </div>
                <Badge className="w-fit uppercase tracking-wider text-[10px] font-bold mb-2 bg-orange-500 text-white border-none">
                  Best for endpoint security
                </Badge>
                <CardTitle className="text-5xl md:text-6xl lg:text-7xl font-bold text-white">
                  Advanced Defense
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-[hsl(221,15%,70%)] text-lg md:text-xl mb-8 leading-relaxed">
                  Deploy advanced, proactive defense mechanisms that neutralize threats in real-time, ensuring your digital sovereignty remains uncompromised.
                </p>
                <ul className="space-y-3">
                  {["Real-Time Threat Detection", "Ransomware Protection", "Threat Intelligence"].map((feature, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-base md:text-lg font-medium text-white">
                      <CheckCircle2 className="size-5 text-orange-500 shrink-0" />
                      {feature}
                    </li>)}
                </ul>
              </CardContent>
              <CardFooter className="pt-6 border-t border-[hsl(221,30%,15%)] flex flex-col gap-3">
                <Button asChild size="lg" className="w-full h-14 text-base md:text-lg bg-orange-500 hover:bg-orange-600 text-white rounded-lg group">
                  <Link to="https://www.jdoqocy.com/click-101434144-15314137" newTab>
                    Visit Site
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}